<template>
  <b-container fluid class="p-0">
    <div class="box-kyc">
      <div class="box-title">
        <div class="text">
          Xác Thực Tài Khoản
        </div>
      </div>
      <div class="content-box">
        <b-form
          @submit.prevent="uploadImage()"
          class="mb-4 box"
          id="uploadImage"
        >
          <div class="form-group mt-4">
            <label class="text-start mb-0">
              Hình ảnh (CMND / CCCD / Hộ Chiếu)
            </label>
            <div class="imgInfo mt-0">
              <p class="text-start">
                <span class="fileSize ">
                  * Đảm bảo rằng hình ảnh đầy đủ và rõ ràng và định dạng là jpg,
                  jpeg, png.
                </span>
                <br />
                <span class="fileSize ">
                  * Vui lòng sử dụng hình ảnh có kích thước tối đa 2MB
                </span>
              </p>
            </div>
            <div
              class="avatarEmpty text-center"
              v-if="!passport_image && UserKYC.status == -1"
            >
              <input
                @change="onFileChange($event, 0)"
                type="file"
                accept=".jpg,.jpeg,.png"
                class="fileUpload"
              />
              <svg
                data-v-de2bfc3e=""
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 89.156 95.1"
              >
                <g
                  data-v-de2bfc3e=""
                  id="upload-and-send"
                  transform="translate(0 0)"
                  opacity="0.3"
                >
                  <path
                    data-v-de2bfc3e=""
                    id="Path_34910"
                    data-name="Path 34910"
                    d="M25.038,1.016a2.972,2.972,0,0,1,4.476,0l20.8,23.775a2.972,2.972,0,0,1-2.241,4.927H36.188V68.353a2.972,2.972,0,0,1-2.972,2.972H21.329a2.972,2.972,0,0,1-2.972-2.972V29.719H6.469a2.972,2.972,0,0,1-2.235-4.927Z"
                    transform="translate(17.306 0)"
                    fill="#fefefe"
                  ></path>
                  <path
                    data-v-de2bfc3e=""
                    id="Path_34911"
                    data-name="Path 34911"
                    d="M77.269,11V28.831H11.888V11H0V34.775a5.944,5.944,0,0,0,5.944,5.944H83.213a5.944,5.944,0,0,0,5.944-5.944V11Z"
                    transform="translate(0 54.381)"
                    fill="#fefefe"
                  ></path>
                </g>
              </svg>
              <p>Kéo và thả tệp vào đây hoặc nhấp vào</p>
            </div>
            <div v-else class="avatarEmpty show-img">
              <img
                :src="
                  UserKYC.status !== -1
                    ? UserKYC.passport_image
                    : passport_image
                "
                width="225"
              />
              <button
                v-if="UserKYC.status == -1"
                class="button removi-img block bg-theme-1 text-white"
                @click="removeImage(0)"
              >
                Xoá
              </button>
            </div>
            <div
              v-if="submitted && !$v.passport_image.required"
              class="invalid-feedback d-block"
            >
              Vui lòng tải lên hình ảnh CMND / CCCD / Hộ Chiếu, đây là trường bắt buộc của
              bạn
            </div>
          </div>

          <div class="form-group mt-4">
            <label class="fileSize">
              Hình ảnh mặt sau (CMND / CCCD / Hộ Chiếu)
            </label>
            <div class="imgInfo">
              <p class="text-start">
                <span class="fileSize ">
                  *Mặt Sau CMND / CCCD / Hộ Chiếu của bạn.
                </span>
                <br />
                <span class="fileSize ">
                  * Đảm bảo rằng hình ảnh đầy đủ và rõ ràng và định dạng là jpg,
                  jpeg, png.
                </span>
                <br />
                <span class="fileSize ">
                  * Vui lòng sử dụng hình ảnh có kích thước tối đa 2MB
                </span>
              </p>
            </div>
            <div
              class="avatarEmpty text-center"
              v-if="!passport_image_selfie && UserKYC.status == -1"
            >
              <input
                @change="onFileChange($event, 1)"
                type="file"
                accept=".jpg,.jpeg,.png"
                class="fileUpload"
              />
              <svg
                data-v-de2bfc3e=""
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 89.156 95.1"
              >
                <g
                  data-v-de2bfc3e=""
                  id="upload-and-send"
                  transform="translate(0 0)"
                  opacity="0.3"
                >
                  <path
                    data-v-de2bfc3e=""
                    id="Path_34910"
                    data-name="Path 34910"
                    d="M25.038,1.016a2.972,2.972,0,0,1,4.476,0l20.8,23.775a2.972,2.972,0,0,1-2.241,4.927H36.188V68.353a2.972,2.972,0,0,1-2.972,2.972H21.329a2.972,2.972,0,0,1-2.972-2.972V29.719H6.469a2.972,2.972,0,0,1-2.235-4.927Z"
                    transform="translate(17.306 0)"
                    fill="#fefefe"
                  ></path>
                  <path
                    data-v-de2bfc3e=""
                    id="Path_34911"
                    data-name="Path 34911"
                    d="M77.269,11V28.831H11.888V11H0V34.775a5.944,5.944,0,0,0,5.944,5.944H83.213a5.944,5.944,0,0,0,5.944-5.944V11Z"
                    transform="translate(0 54.381)"
                    fill="#fefefe"
                  ></path>
                </g>
              </svg>
              <p data-v-de2bfc3e="">
                Kéo và thả tệp vào đây hoặc nhấp vào
              </p>
            </div>
            <div v-else class="avatarEmpty show-img">
              <img
                :src="
                  UserKYC.status !== -1
                    ? UserKYC.passport_image_selfie
                    : passport_image_selfie
                "
                width="225"
              />
              <button
                v-if="UserKYC.status == -1"
                class="button removi-img block bg-theme-1 text-white"
                @click="removeImage(1)"
              >
                Xoá
              </button>
            </div>
            <div
              v-if="submitted && !$v.passport_image_selfie.required"
              class="invalid-feedback d-block"
            >
              Vui lòng tải lên hình ảnh chụp cùng CMND / CCCD / Hộ Chiếu Căn cước công dân, đây
              là trường bắt buộc của bạn
            </div>
          </div>

          <div
            class="d-flex justify-content-center align-items-center submit flex-column mt-5"
          >
            <b-button
              variant="primary"
              v-if="UserKYC.status == -1"
              class="buttonSubmit"
              type="submit"
            >
              Xác Nhận
            </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </b-container>
</template>
//
<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      reader: new FileReader(),
      passport_image: "",
      passport_image_selfie: "",
      kyc: {
        passport_image: "",
        passport_image_selfie: "",
      },
      submitted: false,
    };
  },
  validations: {
    passport_image: {
      required,
    },
    passport_image_selfie: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      UserKYC: "user/UserKYC",
      UserInfo: "user/UserInfo",
    }),
  },

  created() {},
  methods: {
    onFileChange(e, type) {
      const files = e.target.files || e.dataTransfer.files;
      console.log(files);
      if (!files.length) return;

      this.reader.onload = (ev) => {
        if (type === 0) {
          this.passport_image = ev.target.result;
          const [image] = files;
          this.kyc.passport_image = image;
        } else {
          this.passport_image_selfie = ev.target.result;
          const [Selfie] = files;
          this.kyc.passport_image_selfie = Selfie;
        }
      };
      this.reader.readAsDataURL(files[0]);
    },
    uploadImage() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.dispatch("user/req_postKYC", this.kyc);
    },
    removeImage(type) {
      if (type === 0) {
        this.passport_image = "";
      } else {
        this.passport_image_selfie = "";
      }
    },
  },
};
</script>

<style lang="scss">
.box-kyc {
  width: 100%;
  min-height: 40px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.25rem;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 1.25rem;
    background-color: #ffff;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.305);
    .text {
      color: #000;
      font-weight: 600;
      font-size: 20px;
      text-transform: capitalize;
      .text-warning {
        font-size: clamp(15px, 2vw, 16px);
      }
    }
    .icon {
      cursor: pointer;
      img {
        height: 20px;
        width: auto;
      }
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .content-box {
    padding: 1.25rem;
    .text-error {
      color: red;
      font-size: 13px;
      font-weight: 700;
      text-transform: capitalize;
    }
    #Fromdate {
      padding: 2px 5px 0px 0px !important;
    }
    .form-group {
      label {
        font-weight: 600;
        color: #ffff;
        font-size: 16px;
        margin-bottom: 5px;
        text-transform: capitalize;
      }
      select,
      input {
        width: 100%;
        border: 0;
        border-bottom: 2px solid #e9ecef;
        border-radius: 0;
        height: 40px;
        font-size: clamp(15px, 1vw, 16.2px);
        font-weight: 600;
        font-size: 18px;
        color: #ffff;
        &:focus {
          box-shadow: unset;
          border-bottom: 2px solid #009751;
        }
        &::placeholder {
          font-weight: 500;
          font-size: clamp(13px, 1vw, 15px);
        }
      }
      .form-control {
        border: 0;
        border-bottom: 2px solid #e9ecef;
        border-radius: 0;
        height: 40px;
        font-size: clamp(15px, 1vw, 16.2px);
        font-weight: 600;
        font-size: 18px;
        color: #ffff;
        &:focus {
          box-shadow: unset;
          border-bottom: 2px solid #009751;
        }
        &::placeholder {
          font-weight: 500;
          font-size: clamp(13px, 1vw, 15px);
        }
      }
    }
    .close {
      color: #fff;
    }
    .removi-img {
      position: absolute;
      top: calc(50% - 15px);
      left: 0;
      right: 0;
      margin: auto;
      background: #f3d91f;
      border: 1px #f3d91f solid;
      border-radius: 5px;
      padding: 7px 20px;
      opacity: 0;
      z-index: 20;
      width: 200px;
      transition: 0.3s;
      transform: translateY(100%);
      color: #000 !important;
    }
    .show-img:hover .removi-img {
      transform: translateY(0);
      opacity: 1;
    }
    .show-img {
      padding: 10px !important;
      height: auto !important;
      position: relative !important;
    }
    .show-img img {
      position: relative;
      z-index: 10;
      max-width: 225px;
    }
    .show-img {
      &:hover {
        &::after {
          background: rgba(0, 0, 0, 0.3);
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          border-radius: 10px;
          height: 100%;
          z-index: 11;
          content: "";
        }
      }
    }
    svg {
      font-size: 30px;
    }
    #uploadImage {
      .avatarEmpty {
        background: #1111111f;
        padding: 45px 0;
        color: #424242;
        border-radius: 10px;
        height: 180px;
        margin-bottom: 23px;
        width: 100%;
        position: relative;
        cursor: pointer;
        text-align: center;

        .fileUpload {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 22;
          outline: none;
          opacity: 0;
        }

        p {
          font-size: 20px;
          font-weight: 500;
          margin-top: 20px;
          margin-bottom: 0;
          color: #fff;
          opacity: 0.8;
        }
      }

      .imgInfo {
        text-align: center;
        margin-bottom: 20px;

        .colorGreen {
          color: #25e69c;
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
